import { indexPagesData } from 'utils/index-pages-data';

import { ReceiverDetailsTabComponent } from './components/receiver-details/receiver-details.component';
import { ReceiverLogsTabComponent } from './components/receiver-logs/receiver-logs.component';
import { CommentsComponent } from 'shared/comments/comments.component';


export const rightPanelNavs: any[] = [
  {
    title: 'Details',
    name: 'details',
    active: false,
    component: ReceiverDetailsTabComponent,
  },
  {
    title: 'Logs',
    name: 'logs',
    active: false,
    component: ReceiverLogsTabComponent,
  },
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: CommentsComponent,
  }
];
